import {useEffect} from 'react'
import pointerFocusInput from 'ally.js/fix/pointer-focus-input'
import pointerFocusParent from 'ally.js/fix/pointer-focus-parent'
import pointerFocusChildren from 'ally.js/fix/pointer-focus-children'

///////////////////////////////////////////////////////////////////////////////

export const useAlly = () => {
  useEffect(() => {
    const options = {context: '#tamaro-widget'}

    pointerFocusInput(options)
    pointerFocusParent(options)
    pointerFocusChildren(options)
  }, [])
}
